export default __webpack_public_path__ + "static/social-1b01ab20e8f92afdcfcafaee57e03d2d.png";